export default {}



// WEBPACK FOOTER //
// ./src/store/modules/client/state.js